module.exports = __webpack_public_path__ + "img/normal_search.c3f7f736.svg";